import { useState } from 'react'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import useFetchData from '../../hooks/UseFetchData'
import Table from '../../components/his/invoices/Table'
import PageHeader from '../../shared/PageHeader'
import {
  FaArrowCircleLeft,
  FaArrowCircleRight,
  FaFileExcel,
  FaFilePdf,
} from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { ColumnGroup } from 'primereact/columngroup'
import { Row as ColumnRow } from 'primereact/row'

import { flattenFinancialReports } from '../../utils/GroupByItem'
import CustomButton from '../../shared/CustomButton'
import * as XLSX from 'xlsx'
import { formatDateTime } from '../../utils/FormateDateTime'
import Filters from '../../components/his/invoices/Filters'
import { Column } from 'primereact/column'

const columns = t => [
  {
    header: t('Date & Time'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase">
          {t('User Name')}
        </span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {t('Subtotal for')} {row?.user_id}
        </span>
      ) : (
        row?.created_at && formatDateTime(row?.created_at)
      ),
  },
  {
    header: t('Invoice No'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]"></span>
      ) : (
        row?.invoice_number || '-'
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('MRN'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase">
          {row?.created_by}
        </span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]"></span>
      ) : (
        row?.file_number || '-'
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Patient Name'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.group?.patient?.name}
        </span>
      ) : (
        row?.group?.patient?.name
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Patient Share'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px] ">
          {row?.total_patient_share}
        </span>
      ) : (
        row?.group?.patient?.share
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Patient VAT'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_patient_vat}
        </span>
      ) : (
        row?.group?.patient?.vat
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Patient Total'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_patient_amount}
        </span>
      ) : (
        row?.group?.patient.total
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Company Share'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_company_share}
        </span>
      ) : (
        row?.group?.company?.share
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Company VAT'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_company_vat}
        </span>
      ) : (
        row?.group?.company?.vat
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Company Total'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_company_amount}
        </span>
      ) : (
        row?.group?.company?.total
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Discount'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_discount}
        </span>
      ) : (
        row?.total_discount
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('VAT'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_vat}
        </span>
      ) : (
        row?.total_vat
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Gross'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_gross_amount}
        </span>
      ) : (
        row?.total_amount
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Net'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]">
          {row?.total_net_amount}
        </span>
      ) : (
        row?.total_gross_amount
      ),
    headerCellClass: '!bg-gray-200',
  },
  {
    header: t('Payment Method'),
    body: row =>
      row?.isGroupHeader ? (
        <span className="font-bold text-blue-600 text-[14px] uppercase"></span>
      ) : row?.separator ? (
        <span className="font-bold text-black text-[12px]"></span>
      ) : (
        row?.payment_method || '-'
      ),
    headerCellClass: '!bg-gray-200',
  },
]

export const exportInvoicesToExcel = (
  data,
  t,
  fileName = 'user-collection-daily-report.xlsx'
) => {
  const formatted = data?.map(row => {
    const isSeparator = row?.separator
    const isGroupHeader = row?.isGroupHeader

    return {
      [t('Receptionist Name')]: isGroupHeader
        ? row?.userName
        : isSeparator
        ? t('Total')
        : '----',

      [t('Patient Name')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.patient_details?.full_name || '-',

      [t('Patient Phone')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.patient_details?.contact || '-',

      [t('Created By')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.created_by?.name || '-',

      [t('Created At')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : formatDateTime(row?.created_at),

      [t('Sale Type')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.sale_type || '-',

      [t('Sale Reference')]: isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.sale_refrence || '-',

      [t('Sale Amount')]: isGroupHeader
        ? ''
        : isSeparator
        ? row?.total_amount || 0
        : row?.total_gross_amount || 0,
    }
  })

  const worksheet = XLSX.utils.json_to_sheet(formatted)
  worksheet['!cols'] = new Array(Object.keys(formatted[0]).length).fill({
    wch: 20,
  })
  worksheet['!rows'] = new Array(formatted.length).fill({ hpt: 22 })

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    'User Collection Detailed Report'
  )
  XLSX.writeFile(workbook, fileName)
}

export const exportInvoicesToPDF = (
  payload,
  t,
  payloadData,
  fileName = 'user-collection-summary-report.pdf'
) => {
  const data = payload
  const doc = new jsPDF('landscape')

  const lineHeight = 4
  const start_date = moment(payloadData?.start_date).format('DD/MM/YYYY')
  const end_date = moment(payloadData?.end_date).format('DD/MM/YYYY')
  const user_name = payloadData?.user_name || 'All Users'
  const pageWidth = doc.internal.pageSize.getWidth()

  const currentDate = moment().format('dddd Do MMMM, YYYY')
  const periodText = `Daily collection detailed for the period from ${
    start_date || '-'
  } and upto ${end_date || '-'}`

  const reportTitle = t('Daily Collections Summary Report')
  const orgName =
    payloadData?.business_en || payloadData?.business_ar || 'Organization'
  const location = payloadData?.address || 'Location'

  let y = 10

  doc.setFontSize(12)
  doc.setFont('helvetica', 'bold')
  doc.text(orgName, 14, y)
  doc.setFontSize(10)
  doc.setFont('helvetica', 'normal')
  doc.text(location, 14, y + lineHeight)

  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.text(reportTitle, pageWidth - 14, y, { align: 'right' })

  doc.setFontSize(10)
  doc.setFont('helvetica', 'normal')
  doc.text(`Printed On: ${currentDate}`, pageWidth - 14, y + lineHeight, {
    align: 'right',
  })

  y += lineHeight * 2
  doc.setDrawColor(0)
  doc.setLineWidth(0.1)
  doc.line(14, y, pageWidth - 14, y)

  y += 6

  doc.setFontSize(10)
  doc.text(periodText, 14, y)

  y += lineHeight

  doc.text(`User Name: ${user_name || 'All Users'}`, 14, y)
  doc.text(`User ID: ${user_name ? 'N/A' : 'All'}`, 80, y)
  doc.text(`Report For: Finance`, pageWidth - 14, y, { align: 'right' })

  const tableHeaders = [
    t('Receptionist Name'),
    t('Patient Name'),
    t('Patient Phone'),
    t('Created By'),
    t('Created At'),
    t('Sale Type'),
    t('Sale Reference'),
    t('Sale Amount'),
  ]

  const tableData = data.map(row => {
    const isSeparator = row?.separator
    const isGroupHeader = row?.isGroupHeader

    return [
      isGroupHeader ? row?.userName : isSeparator ? t('Total') : '----',

      isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.patient_details?.full_name || '-',

      isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : row?.patient_details?.contact || '-',

      isGroupHeader ? '' : isSeparator ? '----' : row?.created_by?.name || '-',

      isGroupHeader
        ? ''
        : isSeparator
        ? '----'
        : formatDateTime(row?.created_at),

      isGroupHeader ? '' : isSeparator ? '----' : row?.sale_type || '-',

      isGroupHeader ? '' : isSeparator ? '----' : row?.sale_refrence || '-',

      isGroupHeader
        ? ''
        : isSeparator
        ? row?.total_amount?.toFixed(2) || '0'
        : row?.total_gross_amount?.toFixed(2) || '0',
    ]
  })

  autoTable(doc, {
    startY: 40,
    head: [tableHeaders],
    body: tableData,
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 2.5,
    },
    headStyles: {
      fillColor: [22, 160, 133],
      textColor: 255,
      fontStyle: 'bold',
    },
    willDrawCell: data => {
      const rowText = data.cell.text?.[0]

      if (rowText === t('Total')) {
        data.cell.styles.fontStyle = 'bold'
        data.cell.styles.fillColor = [240, 240, 240]
      }
    },
  })

  doc.save(fileName)
}

const UserCollectionDailyReport = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { data, executeFetch, loading } = useFetchData()
  const auth = useSelector(state => state.auth)
  const { filters: payloadData, setFilters: setPayloadData } = usePersistedFilters(
    'invoice_report',
    {
      end_date: moment().toDate(),
      start_date: moment().subtract(1, 'day').toDate(),
      created_by: '',
      cash_invoice_number: '',
      department_id: '',
    }
  )

  const fetchData = async (payload = payloadData) =>
    await executeFetch('POST', '/v3/invoices/getInvoices', {
      ...payloadData,
      start_date: moment(payload.start_date).format('YYYY-MM-DD'),
      end_date: moment(payload.end_date).format('YYYY-MM-DD'),
    })

  const headerGroup = (
    <ColumnGroup>
      <ColumnRow style={{ alignItems: 'end', borderWidth: 1 }}>
        <Column header={t('Date & Time')} rowSpan={2} />
        <Column header={t('Invoice No')} rowSpan={2} />
        <Column header={t('MRN')} rowSpan={2} />

        <Column header={t('Patient')} colSpan={4} align={'center'} />
        <Column header={t('Company')} colSpan={3} align={'center'} />

        <Column header={t('Discount')} rowSpan={2} />
        <Column header={t('VAT')} rowSpan={2} />
        <Column header={t('Net with VAT')} rowSpan={2} />
        <Column header={t('Net w/o VAT')} rowSpan={2} />
        <Column header={t('Payment Method')} rowSpan={2} />
      </ColumnRow>
      <ColumnRow>
        <Column header={t('Name')} />
        <Column header={t('Share')} />
        <Column header={t('VAT')} />
        <Column header={t('Total')} />

        <Column header={t('Share')} />
        <Column header={t('VAT')} />
        <Column header={t('Total')} />
      </ColumnRow>
    </ColumnGroup>
  )

  const footerGroup = (
    <ColumnGroup>
      <ColumnRow style={{ alignItems: 'end', borderWidth: 1 }}>
        <Column
          header={`${t('Subtotal for')} ${payloadData?.created_by}`}
          rowSpan={2}
        />
        <Column header={t('Invoice No')} rowSpan={2} />
        <Column header={t('MRN')} rowSpan={2} />

        <Column header={t('Patient')} colSpan={4} align={'center'} />
        <Column header={t('Company')} colSpan={3} align={'center'} />
      </ColumnRow>
      <ColumnRow>
        <Column header={t('Name')} align={'center'} />
        <Column header={t('Share')} align={'center'} />
        <Column header={t('VAT')} align={'center'} />
        <Column header={t('Total')} align={'center'} />

        <Column header={t('Share')} align={'center'} />
        <Column header={t('VAT')} align={'center'} />
        <Column header={t('Total')} align={'center'} />
      </ColumnRow>
    </ColumnGroup>
  )

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <div className="flex items-center justify-between">
        <PageHeader
          title={t('User Collection Day Report')}
          iconSize={20}
          Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
          onIconClick={() => navigate(-1)}
        />
      </div>

      <div>
        <div className="flex items-center w-full justify-between gap-2 mb-2">
          <Filters
            payloadData={payloadData}
            setPayloadData={setPayloadData}
            fetchData={fetchData}
          />
          <div class=" flex gap-2">
            <CustomButton
              label={t('Export to Excel')}
              buttonType="success"
              icon={FaFileExcel}
              className="w-fit h-[35px]"
              onClick={() => {
                exportInvoicesToExcel(
                  flattenFinancialReports(data?.grouped_reports),
                  t
                )
              }}
            />

            <CustomButton
              label={t('Export to PDF')}
              buttonType="danger"
              icon={FaFilePdf}
              className="w-fit h-[35px]"
              onClick={() => {
                exportInvoicesToPDF(
                  flattenFinancialReports(data?.grouped_reports),
                  t,
                  {
                    ...payloadData,
                    business_en: auth?.buisnessInfo?.name_en,
                    business_ar: auth?.buisnessInfo?.name_ar,
                    address: auth?.buisnessInfo?.address,
                  }
                )
              }}
            />
          </div>
        </div>

        <Table
          data={flattenFinancialReports(data?.grouped_reports)}
          loading={loading}
          columns={columns}
          headerColumnGroup={headerGroup}
        />
      </div>
    </div>
  )
}

export default UserCollectionDailyReport
